
import createIcon from "./createIcon";

export const Heading3Icon = createIcon('Heading3', (props) => {
  return (
    <svg {...props}>
      <path id="H3" d="M2.14 6.73L6.58 6.73L6.58 3.02L7.93 3.02L7.93 12.05L6.58 12.05L6.58 8L2.14 8L2.14 12.05L0.78 12.05L0.78 3.02L2.14 3.02L2.14 6.73ZM15.03 4.15L12.59 6.61L12.61 6.65C13.99 6.51 15.51 7.44 15.51 9.34C15.51 11.08 14.27 12.22 12.45 12.22C11.04 12.22 9.89 11.47 9.4 10.17L10.65 9.72C10.96 10.51 11.55 10.99 12.47 10.99C13.46 10.99 14.14 10.32 14.14 9.34C14.14 8.34 13.48 7.7 12.42 7.7C12.09 7.69 11.79 7.78 11.46 7.98L10.71 6.98L13.24 4.28L9.7 4.28L9.7 3.02L15.03 3.02L15.03 4.15Z" fill={props.color} fillOpacity="1" fillRule="evenodd" />
    </svg >
  )
});
